import { cleanEmptyFilters, filterToExpression } from '@utils/filterUtils';
import { FilterContext, TableDataType } from './types';

export const getTableTypeTitle = (tableType: TableDataType): string => (tableType === TableDataType.INCIDENT ? 'Incidents' : 'Alerts');

export const getNumericValue = (data: any): number => {
  if (typeof data === 'number') return data;
  return 0;
};

export const calculatePercentageChange = (oldValue: number, newValue: number): number => {
  if (oldValue === 0) {
    return 0;
  }
  return ((newValue - oldValue) / oldValue) * 100;
};

export const getLast3MonthsDate = (): Date => {
  const date = new Date();
  date.setMonth(date.getMonth() - 3);
  return date;
};

export const getLast7DaysDate = (): Date => {
  const date = new Date();
  date.setMonth(date.getDay() - 7);
  return date;
};

export const getLast30DaysDate = (date: Date): Date => {
  const Last30Days = new Date(date);
  Last30Days.setDate(Last30Days.getDate() - 30);
  return Last30Days;
};

const createOperandsFromFilters = (filters: any, typeMap: any): any[] => {
  if (filters && Object.keys(filters).length > 0) {
    const generatedFilterExpression = filterToExpression(typeMap, filters);
    const cleanedFilterExpression = cleanEmptyFilters(generatedFilterExpression);

    if (cleanedFilterExpression?.and?.operands) {
      return cleanedFilterExpression.and.operands;
    }
    if (cleanedFilterExpression?.expression) {
      return [cleanedFilterExpression];
    }
  }
  return [];
};

export const createExpressionArrayFromFilters = (filterContext: FilterContext): any[] => {
  const { filters, typeMap, search } = filterContext;

  const searchExpression = search?.term
    ? [
        {
          expression: {
            fieldName: search.field,
            stringCondition: { contains: search.term },
          },
        },
      ]
    : [];

  return [...createOperandsFromFilters(filters, typeMap), ...searchExpression];
};

export const handleNavigation = (filterContext: FilterContext, tableType: TableDataType, navigate: any) => {
  const tableTypeTitle = getTableTypeTitle(tableType);
  const filter = {};

  Object.keys(filterContext.filters).forEach(f => {
    if (filterContext.filters[f].length > 0) {
      filter[f] = filterContext.filters[f];
    }
  });

  const searchParams = {
    ...filter,
    [`${tableType.toLowerCase()}.created`]: encodeURIComponent(
      JSON.stringify({
        value: {
          from: filterContext.dateRange[0].toISOString(),
          to: filterContext.dateRange[1].toISOString(),
        },
      })
    ),
    ticketCategory: ['Threats'],
  };
  // const queryString = flattenToQueryString(searchParams);
  //
  // window.open(`${tableTypeTitle.toLowerCase()}?${queryString}`, '_blank');

  navigate({
    from: '/',
    to: `$accountId/threats/${tableTypeTitle.toLowerCase()}`,
    search: searchParams,
  });
};

// function flattenToQueryString(params) {
//   const flatParams = {};
//
//   Object.keys(params).forEach(key => {
//     const value = params[key];
//
//     if (Array.isArray(value)) {
//       flatParams[key] = JSON.stringify(value);
//     } else {
//       flatParams[key] = value;
//     }
//   });
//
//   return new URLSearchParams(flatParams).toString();
// }
